import { render, staticRenderFns } from "./MoneyWithIndicator.vue?vue&type=template&id=cd04c5a8&"
import script from "./MoneyWithIndicator.vue?vue&type=script&lang=js&"
export * from "./MoneyWithIndicator.vue?vue&type=script&lang=js&"
import style0 from "./MoneyWithIndicator.vue?vue&type=style&index=0&id=cd04c5a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports